import { render, staticRenderFns } from "./Creditfreewait.vue?vue&type=template&id=13118dac&"
import script from "./Creditfreewait.vue?vue&type=script&lang=js&"
export * from "./Creditfreewait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports